import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=da8fc1d2&scoped=true&"
import script from "./Settings.vue?vue&type=script&lang=js&"
export * from "./Settings.vue?vue&type=script&lang=js&"
import style0 from "./Settings.vue?vue&type=style&index=0&id=da8fc1d2&prod&lang=scss&scoped=true&"
import style1 from "./Settings.vue?vue&type=style&index=1&id=da8fc1d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da8fc1d2",
  null
  
)

export default component.exports